var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.808 8.76143C17.1633 9.18738 17.106 9.82068 16.68 10.1759L11.8628 14.1931C11.4902 14.5039 10.9487 14.5039 10.576 14.1931L8.36179 12.3466C7.93576 11.9914 7.87846 11.3581 8.2338 10.9321C8.58914 10.5062 9.22256 10.4489 9.64858 10.8042L11.2194 12.1141L15.3932 8.63348C15.8192 8.2782 16.4526 8.33549 16.808 8.76143Z",
    fill: "#077D3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.77778C2 3.92607 2.53939 3.1678 3.34398 2.88843L11.344 0.110653C11.7689 -0.0368842 12.2311 -0.0368842 12.656 0.110653L20.656 2.88843C21.4606 3.1678 22 3.92607 22 4.77778V10.944C22 14.6838 20.2564 18.2098 17.2845 20.48L13.2141 23.5893C12.4973 24.1369 11.5027 24.1369 10.7859 23.5893L6.71552 20.48C3.74359 18.2098 2 14.6838 2 10.944V4.77778ZM12 2L4 4.77778V10.944C4 14.0605 5.45299 16.9988 7.9296 18.8907L12 22L16.0704 18.8907C18.547 16.9988 20 14.0605 20 10.944V4.77778L12 2Z",
    fill: "#077D3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeShield);
export default __webpack_public_path__ + "static/media/SAFE_SHIELD.3816ed6b5ef3fa5cea0f75467f031c69.svg";
export { ForwardRef as ReactComponent };